export var NavigationStatus;
(function (NavigationStatus) {
    NavigationStatus["NAVIGATING"] = "states_navigating";
    NavigationStatus["INITIALIZED"] = "initialized";
    NavigationStatus["REACHED_ADMIT"] = "reached_admit";
    NavigationStatus["REACHED_DISCHARGE"] = "reached_discharge";
    NavigationStatus["REACHED_REASSESSMENT"] = "reached_reassessment";
    NavigationStatus["REACHED_CC_PROTOCOL_END"] = "reached_cc_protocol_end";
    NavigationStatus["REACHED_OS_PROTOCOL_END"] = "reached_os_protocol_end";
})(NavigationStatus || (NavigationStatus = {}));
//# sourceMappingURL=types.js.map